import * as types from '../../actions/actionTypes';
import initialState from '../initialState';


export default function portalContactPersonReducer(state = initialState.portalContactPerson, action) {
    switch (action.type) {
        case types.GET_PORTAL_CONTACT_SUCCESS:
            return action.portalContact;
        case types.RESET_PORTAL_CONTACT:
            return {...initialState.portalContactPerson};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/portal/portalContactReducer.js